module.exports = __webpack_public_path__ + "images/for_companies_lp/logo_twee_6d43b150ac00a73765a729d808029db8.jpg";